import { COLORS } from "@coeff/utils";
import { Checkbox as CheckboxAD } from "antd";
import React, { useContext } from "react";
import styled from "styled-components";

import { PPressComponentProps, PpressContext, PPressContextParams } from "../context";

const StyledCheckbox = styled(CheckboxAD)`
  .ant-checkbox {
    .ant-checkbox-inner {
      border-width: 2px;
    }

    &.ant-checkbox-checked {
      .ant-checkbox-inner {
        background-color: ${COLORS.coeblue4};
        border-color: ${COLORS.coeblue4};
        border-width: 0px;
      }

      &.ant-checkbox-disabled {
        .ant-checkbox-inner {
          border-color: ${COLORS.coeblue4}!important;

          &:after {
            border-color: ${COLORS.black4}!important;
          }
        }
      }
    }
  }

  &.error {
    .ant-checkbox {
      .ant-checkbox-inner {
        border-color: ${COLORS.red};
      }
    }
  }
`;

type PPressCheckboxProps = {
  className?: string;
  name: string;
} & PPressComponentProps;

export const Checkbox: React.FC<PPressCheckboxProps> = ({ children, ...props }) => {
  const { name, triggersOnChange, updateFromServerOnChange } = props;

  const form_state = useContext(PpressContext) as PPressContextParams;

  return (
    <StyledCheckbox
      checked={form_state.ppress_params[name]}
      className={props.className}
      onChange={async () => {
        if (updateFromServerOnChange) {
          await form_state.updateFormFromServer({
            ...form_state?.ppress_params,
            [name]: !form_state.ppress_params[name],
          });
        } else {
          form_state.updatePPressParams({
            [name]: !form_state.ppress_params[name],
          });

          if (triggersOnChange) {
            form_state.triggersOnChange(triggersOnChange);
          }
        }
      }}
      data-test-id={`ppress-checkbox-${name}`}
    >
      {children}
    </StyledCheckbox>
  );
};
